<template>
  <v-data-table
    v-model="selectedProjects"
    :items="searchProjects"
    :headers-length="2"
    select-all
    hide-actions
  >
    <template v-slot:headers>
      <tr>
        <th class="pa-2 ma-0">
          <v-checkbox
            @change="toggleAll"
            small
            :value="selectAll"
            color="primary"
            hide-details
            class="pa-0 ma-0"
          ></v-checkbox>
        </th>
        <th class="text-uppercase text-xs-left pa-0">
          Project
        </th>
      </tr>
      <tr>
        <th colspan="2" class="pa-2">
          <v-text-field
            v-model="search"
            append-icon="search"
            class="ma-0 pa-0"
            label="Поиск"
            single-line
            small
            hide-details
          ></v-text-field>
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <td class="pa-2 ma-0">
          <v-checkbox
            v-model="props.selected"
            hide-details
            small
            color="primary"
            class="pa-0 ma-0"
          ></v-checkbox>
        </td>
        <td class="text-xs-left pa-2">
          {{ props.item.name }}
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'ProjectsTable',
  props: {
    projects: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      search: '',
      selectedProjects: [],
    };
  },
  watch: {
    projects: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.toggleAll(true);
        });
      },
    },
    selectedProjects(arr) {
      this.$emit('sortByProject', arr.map(prj => prj.id));
    },
  },
  computed: {
    selectAll() {
      return this.selectedProjects.length === this.searchProjects.length;
    },
    searchProjects() {
      return this.projects.filter(item => {
        return item.name
          .toLowerCase()
          .includes(this.search.toLowerCase());
      });
    },
  },
  methods: {
    toggleAll(value) {
      if (value) {
        this.selectedProjects = this.searchProjects;
      } else {
        this.selectedProjects = [];
      }
    },
  },
};
</script>
